import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { ClearButton, SaveButton } from 'irmlib/components/FormControls'
import { FlexByRow, XDivider, YDivider, HalfScreen } from 'irmlib/styles'
import * as constants from 'irmlib/common/constants'
import { useSearchParams } from 'irmlib/hooks'
import { MainRouteSubRoutePage } from '../../../AppControl/RoutePage'
import JobsFilter from '../JobsFilter'
import MyjobpageData from './MyJobsPageDataNew'
import { errorToast } from '../../../../common/functions'
import { useTranslation } from 'react-i18next'


const Buttons = props =>
  <>
    <ClearButton arrRefs={props.arrRefs} />
    <XDivider width='10px' />
    <SaveButton arrRefs={props.arrRefs} />
  </>

Buttons.propTypes = {
  arrRefs: PropTypes.array
}

const VerticalDivider = () =>
  <YDivider height='15px' />



const MyJobsNew = (props) => {
  const dataFilter = [
    { key: 1, label: constants.defaultSelect },
    { key: 2, label: constants.defaultSelect },
    { key: 3, label: constants.defaultSelect },
    { key: 4, label: constants.defaultSelect },
    { key: 5, label: constants.defaultSelect },
    { key: 6, label: constants.defaultSelect },
    { key: 7, label: constants.defaultSelect },
    { key: 8, label: constants.defaultSelect }, 
  ]
  const emptyFilter = {
    deType: constants.defaultSelect,
    templateNAme: constants.defaultSelect,
    jobStatus: constants.defaultSelect,
    customer: constants.defaultForAccountLevel,
    districts: [constants.defaultSelect],
    orderNumber: constants.defaultForAccountLevel,
    initialStatus: 'APPROVED',
    userName: constants.defaultSelect,
    createDateFrom: constants.defaultSelect,
    createDateTo: constants.defaultSelect
  }
  const searchParams = useSearchParams()?.get('status')
  const statusNavParam = searchParams || constants.defaultSelect
  const dataFilter2 = [
    { key: 1, label: statusNavParam },
    { key: 2, label: constants.defaultSelect },
    { key: 3, label: constants.defaultSelect },
    { key: 4, label: constants.defaultSelect },
    { key: 5, label: constants.defaultSelect },
    { key: 6, label: constants.defaultSelect },
    { key: 7, label: constants.defaultSelect },
    { key: 8, label: constants.defaultSelect },
  ]
  const chipsPersist = window.sessionStorage.getItem('persist-filters-MyJobs')
  const chipsPersist1 = JSON.parse(chipsPersist)
  const [chipData, setChipData] = React.useState(searchParams ? dataFilter2 : chipsPersist1 || dataFilter)
  
  const [val, Setval] = React.useState({ ...emptyFilter, jobStatus: statusNavParam, initialStatus: statusNavParam === constants.defaultSelect ? 'NoApprove' : 'APPROVED' })
 
  const { t } = useTranslation()

  useEffect(() => {
    window.sessionStorage.setItem('persist-filters-MyJobs', JSON.stringify(chipData))
  }, [chipData])

  // Persist Filters in local storage
  useEffect(() => {
    window.sessionStorage.setItem('persist-filters-MyJobs', JSON.stringify(chipData))
    chipData.map((data) => {
      if (data.label !== constants.defaultChipLabel && data.label !== constants.defaultSelect && data.label !== constants.defaultForAccountLevel) {
        getSearchdata(chipData)
      }
      return 0
    })
  }, [])

  const setFilterValues = (value) => {
    try {
      const datas = { jobStatus: value[0].label, deType: value[1].label, templateNAme: value[2].label, customer: value[3].label, orderNumber: value[4].label, initialStatus: 'APPROVED', districts: [constants.defaultSelect], userName: value[5].label, createDateFrom: value[6].label, createDateTo: value[7].label }
      for (let i = 8; i < value.length; i++) {
        datas.districts.push(value[i].label)
      }
      // Default initialStatus to NoApprove when there are no filters selected so that trnsmitted jobs are not shown.
      let filterStatus = false
      value.forEach((data) => {
        if (data.label !== constants.defaultSelect && data.label !== constants.defaultForAccountLevel && filterStatus === false) {
          filterStatus = true
        }
      })
      if (!filterStatus) {
        datas.initialStatus = 'NoApprove'
      }
      Setval(datas)
    } catch (err) {
      errorToast({ message: err?.message, title: t('toast.failedToFetch') })
    }
  }
  
  const getSearchdata = (value) => {
    setChipData(value)
    setFilterValues(value)
    return value
  }

  const activeJobStatus = [
    // { value: constants.jobStatus.pending, label: t(`jobStatusObj.${constants.jobStatus.pending}`) },
    { value: constants.jobStatus.assigned, label: t(`jobStatusObj.${constants.jobStatus.assigned}`) },
    { value: constants.jobStatus.inProgress, label: t(`jobStatusObj.${constants.jobStatus.inProgress}`) },
    { value: constants.jobStatus.readyToTransmit, label: t(`jobStatusObj.${constants.jobStatus.readyToTransmit}`) },
    { value: constants.jobStatus.cancel, label: t(`jobStatusObj.${constants.jobStatus.cancel}`) },
    { value: constants.jobStatus.transmitted, label: t(`jobStatusObj.${constants.jobStatus.transmitted}`) },
  ]
  const defaultActiveJobStatus = [
    // t(`jobStatusObj.${constants.jobStatus.pending}`),
    // t(`jobStatusObj.${constants.jobStatus.assigned}`),
    // t(`jobStatusObj.${constants.jobStatus.inProgress}`),
    // t(`jobStatusObj.${constants.jobStatus.readyToTransmit}`),
    constants.jobStatus.assigned,
    constants.jobStatus.inProgress,
    constants.jobStatus.readyToTransmit,
  ]

  const getSelectedData = (data) => {
    if (data.District) {
      if (data.District.length) {
        if (data.District.length > 7) {
          errorToast({ message: t('toast.districtSelection'), title: t('toast.failedToFetch'), autoHideDuration: 3000, isBlocking: false })
        } else {
          if (data.Status) {
            if (data.Status.length) {
              Setval({ ...val, jobStatus: data.Status, districts: data.District, initialStatus: 'APPROVED' })
            } else {
              errorToast({ message: t('toast.invalidStatus'), title: t('toast.error'), autoHideDuration: 3000, isBlocking: false })
            }
          } else {
            Setval({ ...val, districts: data.District })
          }
        }
      } else {
        errorToast({ message: t('toast.invalidDistrict'), title: t('toast.error'), autoHideDuration: 3000, isBlocking: false })
      }
    } else if (data.Status) {
      if (data.Status.length) {
        Setval({ ...val, jobStatus: data.Status, initialStatus: 'APPROVED' })
      } else {
        errorToast({ message: t('toast.invalidStatus'), title: t('toast.error'), autoHideDuration: 3000, isBlocking: false })
      }
    }
  }
  return (
    <MainRouteSubRoutePage
      mainTitle='routeTitles.jobManagement'
      // subTitle='routeTitles.myJobs'
    >
      <FlexByRow>
        <HalfScreen>
          <React.Fragment>
            <FlexByRow>
              <JobsFilter defaultStatus={defaultActiveJobStatus} activeStatus={activeJobStatus} selectedData = {getSelectedData} selectedStatus={Array.isArray(val.jobStatus) ? val.jobStatus : [val.jobStatus]}/>
            </FlexByRow>
          </React.Fragment>
        </HalfScreen>
      </FlexByRow>
      <VerticalDivider/>
      <MyjobpageData FilterData={val} />
    </MainRouteSubRoutePage>
  )
}

export default MyJobsNew
